<template>
  <div class="page-container">
    <header-com></header-com>

    <!-- 用户信息卡片 -->
    <div class="user-info-card" @click="checkLogin">
      <div class="card-header">
        <img
          src="https://www.ptty.com.cn/wap/logo.png?v=20250530"
          class="logo-img"
          alt="平台logo"
        />
        <div class="user-detail">
          <div class="user-name-row">
            <p class="user-name">{{ ryInfo.NIC || "点击登录" }}</p>
            <span
              v-if="ryInfo.isLogin && memberLevel"
              :class="['member-badge', `member-${memberLevel}`]"
            >
            </span>
          </div>
          <p v-if="ryInfo.isLogin" class="user-phone">{{ ryInfo.TEL }}</p>
        </div>
      </div>
    </div>

    <!-- 功能九宫格 -->
    <div class="grid-container">
      <div class="grid-item" @click="myReportTrial">
        <div class="grid-icon" style="background: #E3F2FD;">
          <van-icon name="coupon-o" size="26" color="#2D8CF0" />
        </div>
        <p class="grid-text">我的比赛</p>
      </div>

      <div
        class="grid-item"
        @click="ssTjHandler"
        v-if="openIdEn.length > 0 && telShow.indexOf(ryInfo.TEL) > -1"
      >
        <div class="grid-icon" style="background: #FFF3E0;">
          <van-icon name="medal-o" size="26" color="#FF9900" />
        </div>
        <p class="grid-text">赛区统计</p>
      </div>

      <div class="grid-item" @click="handleGrowthRecord" v-if="false">
        <div class="grid-icon" style="background: #F3E5F5;">
          <van-icon name="bar-chart-o" size="26" color="#9C27B0" />
        </div>
        <p class="grid-text">成长记录</p>
      </div>

      <div class="grid-item" @click="handleMemberBenefits" v-if="false">
        <div class="grid-icon" style="background: #FFF3E0;">
          <van-icon name="vip-card-o" size="26" color="#FF6B00" />
        </div>
        <p class="grid-text">会员权益</p>
      </div>

      <div class="grid-item" @click="connectMe">
        <div class="grid-icon" style="background: #E8F5E9;">
          <van-icon name="phone-o" size="26" color="#19BE6B" />
        </div>
        <p class="grid-text">联系我们</p>
      </div>

      <div class="grid-item" v-if="openIdEn.length > 0" @click="zxUserHandler">
        <div class="grid-icon" style="background: #FFEBEE;">
          <van-icon name="delete-o" size="26" color="#ED4014" />
        </div>
        <p class="grid-text">注销账号</p>
      </div>
    </div>

    <!-- 底部导航 -->
    <van-tabbar
      v-model="bottomMenuActive"
      class="custom-tabbar"
      active-color="#2D8CF0"
    >
      <van-tabbar-item icon="home-o" @click="tabNavToUrl">主页</van-tabbar-item>
      <van-tabbar-item icon="user-o" @click="tabNavToUrl"
        >个人中心</van-tabbar-item
      >
    </van-tabbar>

    <!-- 版权信息 -->
    <div class="footer-copyright">
      <p class="copyright-text">天津跑兔体育科技有限公司©版权所有</p>
      <a href="http://beian.miit.gov.cn/" target="_blank" class="beian-link"
        >津ICP备2023005649号</a
      >
    </div>

    <loading-com />
  </div>
</template>

<script>
import HeaderCom from "../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";

export default {
  components: { HeaderCom, LoadingCom },
  name: "MeIndex",
  data() {
    return {
      bottomMenuActive: 1,
      ryInfo: {
        NIC: "点击登录",
        TEL: "",
        isLogin: false
      },
      openIdEn: "",
      memberLevel: "gold", // 会员等级: silver-白银, gold-黄金, platinum-铂金
      telShow: [
        "18222523531",
        "13302193154",
        "13810635350",
        "15904781800",
        "13651314711",
        "1883914080",
        "15227657212",
        "13691132006",
        "15822526928"
      ]
    };
  },
  computed: {
    memberLevelText() {
      const levelMap = {
        gold: "会员"
      };
      return levelMap[this.memberLevel] || "";
    }
  },
  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    const that = this;
    this.utilPost.getOpenId(function(openId) {
      const ryInfo = that.utilPost.getLogin();
      that.ryInfo = ryInfo;
      that.openIdEn = ryInfo.OPENIDEN || openId;
    });
  },
  methods: {
    ssTjHandler() {
      this.$router.push("/eventStatistics");
    },
    tabNavToUrl() {
      var routeValue = localStorage.getItem("routeValue");
      if (
        routeValue === null ||
        routeValue === undefined ||
        routeValue.length === 0
      ) {
        this.$router.push({
          path: this.bottomMenuActive === 0 ? "/" : "/meIndex"
        });
      } else {
        if (this.bottomMenuActive === 0) {
          window.location.href = "https://www.ptty.com.cn/wap/#/" + routeValue;
        } else {
          this.$router.push({
            path: "/meIndex"
          });
        }
      }
    },
    checkLogin() {
      const openIdEn = localStorage.getItem("openIdEn");
      if (!openIdEn) {
        this.$router.push("/loginIndex");
        return;
      }
      const ryInfoLocal = localStorage.getItem("ryInfo");
      if (!ryInfoLocal) this.$router.push("/loginIndex");
    },
    myReportTrial() {
      if (!this.ryInfo.isLogin) {
        this.$router.push("/loginIndex");
        return;
      }
      this.$router.push("/meBsIndex");
    },
    handleRankList() {
      if (!this.ryInfo.isLogin) {
        this.$router.push("/loginIndex");
        return;
      }
      this.$router.push("/meNewIndex");
    },
    handleGrowthRecord() {
      if (!this.ryInfo.isLogin) {
        this.$router.push("/loginIndex");
        return;
      }
      this.$router.push("/meQygjIndex");
    },
    handleMemberBenefits() {
      // 会员权益页面，无论是否登录都可以查看
      this.$router.push("/memberBenefits");
    },
    connectMe() {
      this.$router.push("/connectMe");
    },
    layout() {
      if (confirm("是否退出当前账号？")) {
        // localStorage.clear();
        this.ryInfo = { NIC: "点击登录", TEL: "", isLogin: false };
      }
    },
    zxUserHandler() {
      if (!confirm("注销后无法恢复，是否继续？")) return;
      const paramData = {
        headerData: { op: "wapGL", methodName: "zxUserHandler" },
        busData: { openIdEn: this.openIdEn }
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        // localStorage.clear();
        localStorage.setItem("openIdEn", "");
        localStorage.setItem("ryInfo", "");
        this.ryInfo = { NIC: "点击登录", TEL: "", isLogin: false };
        if (!data.isSuccess) return alert(data.msg);
        alert("注销成功");
      });
    }
  }
};
</script>

<style scoped>
/* 全局容器 */
.page-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding-bottom: 60px; /* 避免内容被底部导航遮挡 */
}

/* 用户信息卡片 */
.user-info-card {
  margin: 12px 16px;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  cursor: pointer;
}
.card-header {
  display: flex;
  align-items: center;
}
.logo-img {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  object-fit: contain;
}
.user-detail {
  flex: 1;
}
.user-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.user-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin: 0;
}
.user-phone {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* 会员等级徽章 */
.member-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.member-badge .van-icon {
  font-size: 12px;
}

/* 白银会员 */
.member-silver {
  background: linear-gradient(135deg, #e8e8e8 0%, #c0c0c0 100%);
  color: #666;
}

/* 黄金会员 */
.member-gold {
  background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
  color: #8b4513;
}

/* 铂金会员 */
.member-platinum {
  background: linear-gradient(135deg, #e5e4e2 0%, #87ceeb 100%);
  color: #4169e1;
}

/* 功能九宫格 */
.grid-container {
  margin: 0 16px 20px;
  background: #ffffff;
  border-radius: 12px;
  padding: 20px 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 8px;
}

.grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  padding: 12px 8px;
  border-radius: 8px;
}

.grid-item:active {
  transform: scale(0.96);
  background: #f8f9fa;
}

.grid-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  transition: transform 0.3s;
}

.grid-item:active .grid-icon {
  transform: scale(0.95);
}

.grid-text {
  font-size: 13px;
  color: #333;
  margin: 0;
  text-align: center;
  font-weight: 500;
  line-height: 1.4;
}

/* 响应式调整 */
@media (max-width: 375px) {
  .grid-container {
    gap: 12px 6px;
    padding: 16px 8px;
  }

  .grid-icon {
    width: 50px;
    height: 50px;
  }

  .grid-text {
    font-size: 12px;
  }
}

/* 自定义底部导航 */
.custom-tabbar {
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}
.custom-tabbar .van-tabbar-item__text {
  font-size: 12px;
}
.custom-tabbar .van-tabbar-item__icon {
  font-size: 22px;
}

/* 版权信息 */
.footer-copyright {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
}
.copyright-text {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin: 0 0 4px 0;
}
.beian-link {
  display: block;
  font-size: 12px;
  color: #2d8cf0;
  text-align: center;
  text-decoration: none;
}
.beian-link:hover {
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/components/MeIndex/MeIndex.vue